var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},_vm._l((_vm.dataIndexItems),function(data,index){return _c('IndexBlock',{key:index,attrs:{"data":data,"isReady":_vm.isReady},nativeOn:{"mouseenter":function($event){_vm.startLoop(data.url)}}})}))}
var staticRenderFns = []

export { render, staticRenderFns }